<section class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="form-wrapper">
          <div class="form-wrapper__header">
            <h2 data-translation-key="reset_password_change_password">
              {{ 'reset_password.change_password' | translate }}
            </h2>
          </div>

          <app-password-form
            [urlFront]="urlFront"
            [showTermsCheckbox]="false"
            [formType]="'change'"
            [showCurrentPassword]="true"
            (formChange)="onPasswordFormChange($event)"
            (formSubmit)="onSubmit($event)"
            [isLoading]="submit_clicked"
          ></app-password-form>
        </div>
      </div>
    </div>
  </div>
</section>
